<script>
    import { getFormatDateAndTime } from "../../../../../Utils/utilFunctions.svelte";

    import { TableComponentContainer } from "../../../../Common/index.svelte";

    export let row = {};

    // HELPER FUNCTIONS
    const _getScheduleDate = (date) => {
        if (date) {
            const dateArr = date.split("T")[0].split("-");
            if (Number(dateArr[0]) < 1900) return "-";
            return getFormatDateAndTime(date);
        } else return "-";
    };
</script>

<TableComponentContainer customContainerClass="min-w-[160px]">
    <div class="flex flex-1 items-center justify-start">
        <p class="text-left">
            {_getScheduleDate(row.scheduledDate)}
        </p>
    </div>
</TableComponentContainer>
